<template>
  <div>
    <v-container>
      <v-card class="pa-5">
        <v-row>
          <v-row justify="center">
            <h1 class="primary--text mt-1">ปฏิทินกิจกรรมรายสัปดาห์</h1>
            <!-- <pre>{{event_list}}</pre> -->
            <!-- <v-btn
              class="float-right ml-5 mt-0"
              color="#636262"
              text
              fab
              @click="openSetting()"
              v-if="mode"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>-->
          </v-row>

          <v-btn
            v-if="event_list.length > 0"
            @click="$router.push('/activitycalendar')"
            color="primary"
            dark
            text
            class="float-right mt-1 font-weight-bold"
            style="font-size:16px; font-weight:bold;"
          >
            ดูทั้งหมด
            <!-- <v-icon class="ml-1">mdi-plus</v-icon> -->
          </v-btn>
        </v-row>

        <v-row>
          <v-col cols="12" md="12">
            <v-card-title v-if="event_list.length == 0">- ไม่มีข้อมูล -</v-card-title>
            <!-- <v-list two-line>
              <v-list-item-group>
                <template v-for="(item, index) in event_list">
                  <v-list-item :key="item.date" v-show="index <= 6">
                    <template>
                      <v-list-item-content>
                        <v-list-item-title
                          style="font-size:18px;"
                          v-text="thaiShortFormatDate(item.date)"
                        ></v-list-item-title>

                        <v-list-item-subtitle style="font-size:16px;" v-text="item.subtitle"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-list-item>

                  <v-divider v-if="index  < event_list.length" :key="index"></v-divider>
                </template>
              </v-list-item-group>
            </v-list>-->
            <v-expansion-panels focusable flat>
              <v-expansion-panel v-for="(item, index) in event_list" :key="item.date">
                <v-expansion-panel-header style="font-size:18px;">
                  {{
                  thaiShortFormatDate(item.date) +
                  (item.data.length != 0
                  ? " (" + item.data.length + " กิจกรรม)"
                  : "")
                  }}
                </v-expansion-panel-header>

                <v-expansion-panel-content
                  class="pt-2"
                  style="font-size:16px;"
                  v-if="item.data == ''"
                >- ไม่มีข้อมูล</v-expansion-panel-content>

                <v-expansion-panel-content
                  v-for="(data, index) in item.data"
                  :key="index"
                  class="pt-2"
                >
                  <v-list-item-subtitle style="font-size:16px;" v-text="data.subtitle"></v-list-item-subtitle>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
          <!-- <v-col cols="12" md="5" v-if="event_list.length > 0">
            <v-img class="pic_calendar" src="../../assets/image/calendar.jpg"></v-img>
          </v-col>-->
        </v-row>
      </v-card>
    </v-container>
    <DialogCalendar ref="dialog_calendar_setting"></DialogCalendar>
  </div>
</template>
<script>
import DialogCalendar from "../Settings/DialogCalendar";
export default {
  components: {
    DialogCalendar,
  },
  data: () => ({
    mode: false,
    today: new Date().toISOString().substr(0, 10),
    item: [],
    // items: [
    //   {
    //     date: "14 มิ.ย.63",

    //     subtitle: "งานภายในการควบคุมดูแลของวิสัญญีแพทย์"
    //   },
    //   {
    //     date: "16 มิ.ย.63",

    //     subtitle: "งานภายในการควบคุมดูแลของวิสัญญีแพทย์"
    //   },
    //   {
    //     date: "18 มิ.ย.63",

    //     subtitle: "งานภายในการควบคุมดูแลของวิสัญญีแพทย์"
    //   },
    //   {
    //     date: "21 มิ.ย.63",

    //     subtitle: "งานภายในการควบคุมดูแลของวิสัญญีแพทย์"
    //   },
    //   {
    //     date: "25 มิ.ย.63",

    //     subtitle: "งานภายในการควบคุมดูแลของวิสัญญีแพทย์"
    //   }
    // ],
    event_list: [],
  }),
  created() {
    this.mode = this.$session.get("token")
      ? this.$session.get("permission") == "admin"
      : false;

    this.getEventByWeek();
  },
  methods: {
    logout() {
      this.$session.clear();
    },
    openSetting() {
      this.$refs.dialog_calendar_setting.openSetting();
    },
    getEventByWeek() {
      var date = this.today;
      var yy = date.split("-")[0];
      var mm = date.split("-")[1];
      var dd = date.split("-")[2];
      var params = dd + "-" + mm + "-" + yy;
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/calendars_week/" + params)
        .then((res) => {
          var data = res.data.data;
          // console.log(data);
          var key = [];
          // key = Object.keys(data);

          var event_list = [];
          let curr = new Date();
          let week = [];

          for (let i = 1; i <= 7; i++) {
            let first = curr.getDate() - curr.getDay() + i;
            let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
            week.push({ date: day, data: [] });
          }

          var event_list = [];
          var unique_id = [];
          data.forEach((element) => {
            if (!unique_id.includes(element.event_id)) {
              unique_id.push(element.event_id);
              event_list.push({
                date: element.event_start_date,
                subtitle: element.event_name,
                category_id: element.category_id,
                category_name: element.category_name,
                event_detail: element.event_detail,
                event_end_date: element.event_end_date,
                event_end_time: element.event_end_time,
                event_file: [],
                // event_file_id: element.event_file_id,
                // event_file_path: element.event_file_path,
                event_id: element.event_id,
                event_name: element.event_name,
                event_position_id: element.event_position_id,
                event_start_date: element.event_start_date,
                event_start_time: element.event_start_time,
              });
            }
          });
          data.forEach((element) => {
            event_list.forEach((event) => {
              if (event.event_id == element.event_id) {
                if (element.event_file_id) {
                  event.event_file.push({
                    event_file_id: element.event_file_id,
                    event_file_path: element.event_file_path,
                  });
                }
              }
            });
          });
          event_list.forEach((element) => {
            week.forEach((week) => {
              if (
                new Date(week.date) >= new Date(element.event_start_date) &&
                new Date(week.date) <= new Date(element.event_end_date)
              ) {
                if (this.$session.get("token")) {
                  week.data.push({
                    date: element.event_start_date,
                    subtitle: element.event_name,
                    category_id: element.category_id,
                    category_name: element.category_name,
                    event_detail: element.event_detail,
                    event_end_date: element.event_end_date,
                    event_end_time: element.event_end_time,
                    event_file: element.event_file,
                    // event_file_id: element.event_file_id,
                    // event_file_path: element.event_file_path,
                    event_id: element.event_id,
                    event_name: element.event_name,
                    event_position_id: element.event_position_id,
                    event_start_date: element.event_start_date,
                    event_start_time: element.event_start_time,
                  });
                } else {
                  if (
                    element.event_position_id != 1 &&
                    element.event_position_id != 2 &&
                    element.event_position_id != 3
                  ) {
                    // if (element.event_position_id == 7) {
                    //   if (element.category_id != 5) {
                    week.data.push({
                      date: element.event_start_date,
                      subtitle: element.event_name,
                      category_id: element.category_id,
                      category_name: element.category_name,
                      event_detail: element.event_detail,
                      event_end_date: element.event_end_date,
                      event_end_time: element.event_end_time,
                      event_file: element.event_file,
                      // event_file_id: element.event_file_id,
                      // event_file_path: element.event_file_path,
                      event_id: element.event_id,
                      event_name: element.event_name,
                      event_position_id: element.event_position_id,
                      event_start_date: element.event_start_date,
                      event_start_time: element.event_start_time,
                    });
                  }
                  //   } else {
                  //     week.data.push({
                  //       date: element.event_start_date,
                  //       subtitle: element.event_name,
                  //       category_id: element.category_id,
                  //       category_name: element.category_name,
                  //       event_detail: element.event_detail,
                  //       event_end_date: element.event_end_date,
                  //       event_end_time: element.event_end_time,
                  //       event_file: element.event_file,
                  //       // event_file_id: element.event_file_id,
                  //       // event_file_path: element.event_file_path,
                  //       event_id: element.event_id,
                  //       event_name: element.event_name,
                  //       event_position_id: element.event_position_id,
                  //       event_start_date: element.event_start_date,
                  //       event_start_time: element.event_start_time,
                  //     });
                  //   }
                  // }
                }
              }
            });
          });
          // console.log(week);
          // key.forEach((element) => {
          //   var week = data[element];
          //   week.forEach((e2) => {
          //     event_list.push(e2);
          //   });
          // });
          // // console.log(event_list);
          // var all_event_by_week = [];
          // // event_list.forEach((element) => {
          // //   all_event_by_week.push({
          // //     date: element.event_start_date,
          // //     subtitle: element.event_name,
          // //   });
          // // });
          // // let data_date = [];
          // // for (let index = n; index <= 1; index--) {
          // //   data_date.push(dd - index + "-" + mm + "-" + yy);
          // // }

          // let curr = new Date();
          // let week = [];

          // for (let i = 1; i <= 7; i++) {
          //   let first = curr.getDate() - curr.getDay() + i;
          //   let day = new Date(curr.setDate(first)).toISOString().slice(0, 10);
          //   week.push(day);
          // }
          // // console.log(week);
          // let data_date = [];
          // week.forEach((element) => {
          //   data_date.push({ date: element, data: [] });
          // });
          // let by_week = [];
          // event_list.forEach((element) => {
          //   if (this.$session.get("token")) {
          //     data_date.forEach((week) => {
          //       if (element.event_start_date == week.date) {
          //         if (!by_week.includes(element.event_id)) {
          //           by_week.push(element.event_id);
          //           week.data.push({
          //             date: element.event_start_date,
          //             subtitle: element.event_name,
          //             category_id: element.category_id,
          //             category_name: element.category_name,
          //             event_detail: element.event_detail,
          //             event_end_date: element.event_end_date,
          //             event_end_time: element.event_end_time,
          //             event_file: [],
          //             // event_file_id: element.event_file_id,
          //             // event_file_path: element.event_file_path,
          //             event_id: element.event_id,
          //             event_name: element.event_name,
          //             event_position_id: element.event_position_id,
          //             event_start_date: element.event_start_date,
          //             event_start_time: element.event_start_time,
          //           });
          //         }
          //       }
          //     });
          //   } else {
          //     if (
          //       element.event_position_id != 1 &&
          //       element.event_position_id != 2 &&
          //       element.event_position_id != 3
          //     ) {
          //       if (element.event_position_id == 7) {
          //         if (element.category_id != 5) {
          //           data_date.forEach((week) => {
          //             if (element.event_start_date == week.date) {
          //               if (!by_week.includes(element.event_id)) {
          //                 by_week.push(element.event_id);
          //                 week.data.push({
          //                   date: element.event_start_date,
          //                   subtitle: element.event_name,
          //                   category_id: element.category_id,
          //                   category_name: element.category_name,
          //                   event_detail: element.event_detail,
          //                   event_end_date: element.event_end_date,
          //                   event_end_time: element.event_end_time,
          //                   event_file: [],
          //                   // event_file_id: element.event_file_id,
          //                   // event_file_path: element.event_file_path,
          //                   event_id: element.event_id,
          //                   event_name: element.event_name,
          //                   event_position_id: element.event_position_id,
          //                   event_start_date: element.event_start_date,
          //                   event_start_time: element.event_start_time,
          //                 });
          //               }
          //             }
          //           });
          //         }
          //       }
          //     }
          //   }
          // });

          // event_list.forEach((element) => {
          //   data_date.forEach((week) => {
          //     week.data.forEach((item) => {
          //       if (item.event_id == element.event_id) {
          //         item.event_file.push({
          //           event_file_id: element.event_file_id,
          //           event_file_path: element.event_file_path,
          //         });
          //       }
          //     });
          //   });
          // });
          // // console.log(data_date);
          this.event_list = week;
        });
    },
    thaiShortFormatDate(date_str) {
      // console.log(date_str);
      // date =  yyyy-mm-dd <2020>
      if (!date_str) {
        return "";
      }
      var [year, month, day] = date_str.split("-");
      year = parseInt(year) + 543;
      var str = year.toString();
      var res = str.substring(2);
      year = res;
      switch (month) {
        case "01":
          month = "ม.ค.";
          break;
        case "02":
          month = "ก.พ.";
          break;
        case "03":
          month = "มี.ค.";
          break;
        case "04":
          month = "เม.ย.";
          break;
        case "05":
          month = "พ.ค.";
          break;
        case "06":
          month = "มิ.ย.";
          break;
        case "07":
          month = "ก.ค.";
          break;
        case "08":
          month = "ส.ค.";
          break;
        case "09":
          month = "ก.ย.";
          break;
        case "10":
          month = "ต.ค.";
          break;
        case "11":
          month = "พ.ย.";
          break;
        case "12":
          month = "ธ.ค.";
          break;

        default:
          break;
      }
      return day + " " + month + " " + year;
    },
  },
};
</script>
